export default __webpack_public_path__ + "static/media/banner.42c54d69.png";